/**
 * tinymce register
 * Register listener for the loaded document and apply tinyMCE to the element, if necessary
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

;(function($, tinymce) {

    "use strict";

    $(function(){

        var $selectorName = '.tinymce';

        // List all possible areas
        var $requested = $($selectorName);

        // if at least one is present
        if ($requested.length > 0){
            tinymce.init({
                selector   : $selectorName,
                body_class : 'tinymce_body',
                skin       : false,
                min_height : 100,
                menubar    : false,
                statusbar  : false,
                plugins    : "autoresize paste",
                toolbar    : 'undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link',
                content_css:'/css/app.css',
                paste_data_images: true,
            });
        }
    });

})(window.jQuery, tinymce);
